// extracted by mini-css-extract-plugin
export var period = "timeline-item-module--period--e4E8L";
export var periodText = "timeline-item-module--period-text--ZLx3B";
export var title = "timeline-item-module--title--Fwwlm";
export var description = "timeline-item-module--description--aZKxF";